import styled from "styled-components";
import { mediaMaxWidth, mediaMinWidth } from "../../utils/mediaQueriesTemplate";

export const NotificationsWrapper = styled.div`
  background: #e4e5e7;
  width: calc(100vw - 60px);
  height: ${(props) =>
    props.iOS ? "calc(100vh - 210px)" : "calc(100vh - 140px)"};
  overflow: auto;
  border-top-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 0 10px;
  margin: 56px 0 0 60px;
  position: fixed;
  top: 72px;

  &::-webkit-scrollbar {
    display: none;
  }

  ${mediaMaxWidth.smallDesktop`
    width: 100vw;
    margin: 56px 0 0 0;
  `}
`;

export const ItemsWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 auto;
  width: 70vw;

  ${mediaMinWidth.desktop`
    width: 50vw;
  `}

  ${mediaMaxWidth.desktop`
    width: 60vw;
  `}

  ${mediaMaxWidth.smallDesktop`
    width: 65vw;
  `}

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 20px);
  `}
`;

export const Item = styled.li`
  margin: 5px 0;

  &:first-child {
    margin: 0 0 5px 0;
  }

  &:last-child {
    margin: 5px 0 0 0;
  }
`;

export const Subject = styled.div`
  font-size: 0.95em;
  font-weight: 600;
  color: #333333;
  opacity: 0.8;
  letter-spacing: 0.015em;
  width: 330px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.phone`
    display: unset;
    width: 200px;
    padding-left: 10px;
    font-size: 0.85em;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 180px; 
    padding-left: 0;
  `}
`;

export const NotificationText = styled.div`
  font-size: 1em;
  color: #333333;
  opacity: 0.6;
  font-style: italic;
  letter-spacing: 0.015em;
  line-height: 1.3em;
  word-break: break-word;
  padding-top: 5px;
  display: flex;
  flex: 2;

  ${mediaMaxWidth.phone`
    padding-left: 10px;
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.smallPhone`
    padding-left: 0;
  `}
`;

export const Time = styled.div`
  font-size: 0.95em;
  font-style: italic;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  padding: 3px 0 0 0;
  letter-spacing: 0.015em;
  color: #333333;
  opacity: 0.6;
  text-align: right;

  ${mediaMaxWidth.smallDesktop`
    flex: 2;
  `}

  ${mediaMaxWidth.phone`
    font-size: 0.85em;
    padding-top: 0;
  `}

  ${mediaMaxWidth.smallPhone`
    position: relative;
    left: -5px;
    width: 50px;
  `}
`;

export const NotificationLink = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 90px;
  color: #333 !important;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  background-color: #fff;
  border: 2px solid #e4e5e7;

  &:hover {
    background-color: #f5f5f5;
  }

  &.read-false {
    background-color: #673490;
    border: 2px solid #fff;

    i {
      color: #fff;
    }

    ${Subject} {
      color: #fff;
      opacity: 1;
    }

    ${NotificationText},
    ${Time} {
      color: #fff;
      opacity: 0.7;
    }
  }

  ${mediaMaxWidth.phone`
    height: 100px;
  `}

  ${mediaMaxWidth.smallPhone`
    padding: 10px;
  `}
`;

export const AboutNotification = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex: 1;

  ${mediaMaxWidth.smallPhone`
    width: 40px;
  `}
`;

export const NotificationIcon = styled.i`
  display: flex;
  padding: 5px 0 0 0;
  color: #e0e0e0;

  &.fa-file-alt,
  &.fa-calendar-alt {
    font-size: 1.9em !important;
  }

  &.fa-hands-helping,
  &.fa-pencil-alt,
  &.fa-envelope,
  &.fa-exchange-alt,
  &.fa-users,
  &.fa-user-friends,
  &.fa-phone,
  &.fa-calendar-alt,
  &.fa-thumbs-up,
  &.fa-thumbs-down {
    font-size: 1.7em !important;
  }

  &.notification {
    height: 50px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;

    ${mediaMaxWidth.phone`
      justify-content: flex-start;

      &.fa-file-alt,
      &.fa-calendar-alt {
        font-size: 1.6em !important;
      }

      &.fa-hands-helping,
      &.fa-pencil-alt,
      &.fa-users,
      &.fa-envelope,
      &.fa-user-friends,
      &.fa-calendar-alt,
      &.fa-phone,
      &.fa-thumbs-up,
      &.fa-thumbs-down {
        font-size: 1.4em !important;
      }
    `}
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex: 9;
  flex-direction: column;

  ${mediaMaxWidth.phone`
    flex: 7;
  `}
`;

export const NoContent = styled.p`
  display: flex;
  justify-content: center;
  font-size: 1em;
  font-style: italic;
  margin-top: 80px;
`;
